import logo1 from "../../../Assets/Home/logos/mix-logo-1.jpeg";
import logo2 from "../../../Assets/Home/logos/mix-logo-2.jpeg";
import logo3 from "../../../Assets/Home/logos/mix-logo-3.jpeg";
import logo4 from "../../../Assets/Home/logos/mix-logo-4.jpeg";
import logo5 from "../../../Assets/Home/logos/mix-logo-5.jpeg";
import logo6 from "../../../Assets/Home/logos/mix-logo-6.jpeg";
import logo7 from "../../../Assets/Home/logos/mix-logo-7.jpeg";
import logo8 from "../../../Assets/Home/logos/mix-logo-8.jpeg";
import logo9 from "../../../Assets/Home/logos/mix-logo-9.jpeg";
import logo10 from "../../../Assets/Home/logos/mix-logo-10.jpeg";
import logo11 from "../../../Assets/Home/logos/mix-logo-11.jpeg";
import logo12 from "../../../Assets/Home/logos/mix-logo-12.jpeg";
import logo13 from "../../../Assets/Home/logos/mix-logo-13.jpeg";
import logo14 from "../../../Assets/Home/logos/mix-logo-14.jpeg";
import logo15 from "../../../Assets/Home/logos/mix-logo-15.jpeg";
import logo16 from "../../../Assets/Home/logos/mix-logo-16.jpeg";
import logo17 from "../../../Assets/Home/logos/mix-logo-17.jpeg";

import logo18 from "../../../Assets/Home/logos/mix-logo-18.jpeg";
import logo19 from "../../../Assets/Home/logos/mix-logo-19.jpeg";
import logo20 from "../../../Assets/Home/logos/mix-logo-20.jpeg";
import logo21 from "../../../Assets/Home/logos/mix-logo-21.jpeg";
import logo22 from "../../../Assets/Home/logos/mix-logo-22.jpeg";
import logo23 from "../../../Assets/Home/logos/mix-logo-23.jpeg";
import logo24 from "../../../Assets/Home/logos/mix-logo-24.jpeg";
import logo25 from "../../../Assets/Home/logos/mix-logo-25.jpeg";
import logo26 from "../../../Assets/Home/logos/mix-logo-26.jpeg";
import logo27 from "../../../Assets/Home/logos/mix-logo-27.jpeg";
import logo28 from "../../../Assets/Home/logos/mix-logo-28.jpeg";
import logo29 from "../../../Assets/Home/logos/mix-logo-29.jpeg";
import logo30 from "../../../Assets/Home/logos/mix-logo-30.jpeg";
import logo31 from "../../../Assets/Home/logos/mix-logo-31.jpeg";
import logo32 from "../../../Assets/Home/logos/mix-logo-32.jpeg";
import logo33 from "../../../Assets/Home/logos/mix-logo-33.jpeg";
import logo34 from "../../../Assets/Home/logos/mix-logo-34.jpeg";
import logo35 from "../../../Assets/Home/logos/mix-logo-35.jpeg";
import logo36 from "../../../Assets/Home/logos/mix-logo-36.jpeg";
import logo37 from "../../../Assets/Home/logos/mix-logo-37.jpeg";
import logo38 from "../../../Assets/Home/logos/mix-logo-38.jpeg";
import logo39 from "../../../Assets/Home/logos/mix-logo-39.jpeg";
import logo40 from "../../../Assets/Home/logos/mix-logo-40.jpeg";
import logo41 from "../../../Assets/Home/logos/mix-logo-41.jpeg";
import logo42 from "../../../Assets/Home/logos/mix-logo-42.jpeg";
import logo43 from "../../../Assets/Home/logos/mix-logo-43.jpeg";

export default function MixMastersPartners1() {
  const partners = [
    { id: 1, logo: logo1 },
    { id: 2, logo: logo2 },
    { id: 3, logo: logo3 },
    { id: 4, logo: logo4 },
    { id: 5, logo: logo5 },
    { id: 6, logo: logo6 },
    { id: 7, logo: logo7 },
    { id: 8, logo: logo8 },
    { id: 9, logo: logo9 },
    { id: 10, logo: logo10 },
    { id: 11, logo: logo11 },
    { id: 12, logo: logo12 },
    { id: 13, logo: logo13 },
    { id: 14, logo: logo14 },
    { id: 15, logo: logo15 },
    { id: 16, logo: logo16 },
    { id: 17, logo: logo17 },
    { id: 18, logo: logo18 },
    { id: 19, logo: logo19 },
    { id: 20, logo: logo20 },
    { id: 21, logo: logo21 },
    { id: 22, logo: logo22 },
    { id: 23, logo: logo23 },
    { id: 24, logo: logo24 },
    { id: 25, logo: logo25 },
    { id: 26, logo: logo26 },
    { id: 27, logo: logo27 },
    { id: 28, logo: logo28 },
    { id: 29, logo: logo29 },
    { id: 30, logo: logo30 },
    { id: 31, logo: logo31 },
    { id: 32, logo: logo32 },
    { id: 33, logo: logo33 },
    { id: 34, logo: logo34 },
    { id: 35, logo: logo35 },
    { id: 36, logo: logo36 },
    { id: 37, logo: logo37 },
    { id: 38, logo: logo38 },
    { id: 39, logo: logo39 },
    { id: 40, logo: logo40 },
    { id: 41, logo: logo41 },
    { id: 42, logo: logo42 },
    { id: 43, logo: logo43 },
  ];

  const allPartners = [...partners, ...partners, ...partners];

  return (
    <div className="w-full bg-white py-10 overflow-hidden">
      {/* Label */}
      <div className="text-center mb-6">
        <span className="text-[#c020d0] text-xs font-semibold tracking-[0.22em] uppercase">
          [Clients Partner]
        </span>
      </div>
      {/* Wrapper */}
      <div className="relative w-full overflow-hidden">
        {/* Left Fade */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />

        {/* Right Fade */}
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        {/* Logo Track */}
        <div className="flex gap-10 w-max animate-scroll-right px-10 hover:[animation-play-state:paused]">
          {allPartners.map((p, i) => (
            <div
              key={`${p.id}-${i}`}
              className="flex items-center justify-center w-[120px] h-[90px] bg-white rounded-xl shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-lg flex-shrink-0"
            >
              <img
                src={p.logo}
                alt="partner-logo"
                className="max-h-20 object-cover"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Tailwind Animation */}
      <style>
        {`
       @keyframes scroll-left {
  0% { transform: translateX(0); }
  100% { transform: translateX(-33.333%); }
}

@keyframes scroll-right {
  0% { transform: translateX(-33.333%); }
  100% { transform: translateX(0); }
}

.animate-scroll-left {
  animation: scroll-left 20s linear infinite;
}

.animate-scroll-right {
  animation: scroll-right 30s linear infinite;
}
        `}
      </style>
    </div>
  );
}
